export class Chatbot {
    constructor(
      public id?: number,
      public wrModule?: string,
      public accessToken?: string,
      public serverBaseUrl?: string,
      public apiVersion?: string,
      public apiLanguage?: string
    ) { }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/chatbot.model.ts